import { bindActions, type ActionHandler } from "./actions.ts";
import { bindCalendarController } from "../features/calendar/controller.ts";
import { bindShellNavigation } from "../features/navigation/shell-navigation-controller.ts";
import { bindTaskComposerController } from "../features/tasks/task-composer-controller.ts";
import { bindTaskListController } from "../features/tasks/task-list-controller.ts";
import { bindTaskSubmission } from "../features/tasks/task-submission-controller.ts";

export interface ShellEventBindings {
  navigation: Parameters<typeof bindShellNavigation>[1];
  action: ActionHandler;
  taskList: Parameters<typeof bindTaskListController>[1];
  calendar: Parameters<typeof bindCalendarController>[1];
  bindComments: (document: Document) => void;
  bindAttachments: (document: Document) => void;
  bindTaskReordering: () => void;
  bindBoardDragging: () => void;
  bindSubtaskReordering: () => void;
  bindTaskRowSwipes: () => void;
  submission: Parameters<typeof bindTaskSubmission>[1];
  composer: Parameters<typeof bindTaskComposerController>[1];
  composerSignature: (form: HTMLFormElement) => string;
}

export function bindShellFeatureEvents(document: Document, bindings: ShellEventBindings): void {
  bindShellNavigation(document, bindings.navigation);
  bindActions(document, bindings.action, "[data-action]:not([data-action=remove-subtask])");
  bindTaskListController(document, bindings.taskList);
  bindCalendarController(document, bindings.calendar);
  bindings.bindComments(document);
  bindings.bindAttachments(document);
  bindings.bindTaskReordering();
  bindings.bindBoardDragging();
  bindings.bindSubtaskReordering();
  bindings.bindTaskRowSwipes();

  const form = document.querySelector<HTMLFormElement>("#detail-form");
  if (!form) return;
  bindTaskSubmission(form, bindings.submission);
  form.dataset.initialState = bindings.composerSignature(form);
  bindTaskComposerController(form, bindings.composer);
}
